import { render } from "./BoxWithStyle1.vue?vue&type=template&id=6ad68d58&scoped=true"
import script from "./BoxWithStyle1.vue?vue&type=script&lang=js"
export * from "./BoxWithStyle1.vue?vue&type=script&lang=js"

import "./BoxWithStyle1.vue?vue&type=style&index=0&id=6ad68d58&scoped=true&lang=css"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/wanfei-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad68d58"]])

export default __exports__